import { api } from '@/api/client'
import type { StoredMessage } from '@/lib/messageStore'

/**
 * Resposta do endpoint de sync incremental de mensagens do chat.
 *
 * `items`   = mensagens NOVAS (id > since) UNION mensagens antigas mutadas
 *             (editadas/apagadas desde `changed_since`).
 * `next_cursor` = avança `since` (null = fim da paginação de novas).
 * `changed_max` = avança `changed_since` (maior edited/deleted visto).
 */
export interface SyncResponse {
  items: StoredMessage[]
  next_cursor: number | null
  changed_max: string | null
}

/**
 * GET /api/v1/me/messages/sync — busca uma página do sync incremental.
 *
 * @param since       cursor de id (novas mensagens com id > since)
 * @param changedSince ISO da última mutação vista (null = sem filtro delta)
 * @param limit       tamanho da página (default 500)
 */
export async function fetchMessageSync(
  since: number,
  changedSince: string | null,
  limit = 500,
): Promise<SyncResponse> {
  const res = await api.get<SyncResponse>('/v1/me/messages/sync', {
    params: {
      since,
      limit,
      ...(changedSince ? { changed_since: changedSince } : {}),
    },
  })
  return res.data
}
